import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const SLIDES = [{
  src: 'https://cdn.magicpatterns.com/uploads/4XpRydE47nCCvxKKg1MWyF/IMG_5898_(1).jpg',
  caption: 'Tapa Oficial — Álbum FIFA World Cup 2026'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/x8YnnEcuvRWGdEDd99n4cZ/IMG_5905.jpg',
  caption: '🇦🇷 Argentina — Messi, Dibu Martínez, Julián Álvarez y todo el plantel'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/fAt5ZkWmPgBzrZzuFxm8px/IMG_5908.jpg',
  caption: '🇧🇷 Brasil — Vinícius Jr., Casemiro, Raphinha y toda la canarinha'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/amGETXDAjrYWkjf5GEv1vk/IMG_5907.jpg',
  caption: '🇫🇷 Francia — Mbappé, Dembélé, Tchouaméni y los Bleus'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7LpQYCTX8H9hKsNB8B3iep/IMG_5906.jpg',
  caption: '🇵🇹 Portugal — Cristiano Ronaldo, Bruno Fernandes, Bernardo Silva'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/wkSQiD7erS4c5eSG4qXLtL/IMG_5930.webp',
  caption: '👨‍👦 Viví el Mundial en familia — pegá las figuritas como siempre soñaste'
}];
export function AlbumCarousel() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const next = useCallback(() => {
    setDirection(1);
    setIndex(i => (i + 1) % SLIDES.length);
  }, []);
  const prev = useCallback(() => {
    setDirection(-1);
    setIndex(i => (i - 1 + SLIDES.length) % SLIDES.length);
  }, []);
  const goTo = (i: number) => {
    setDirection(i > index ? 1 : -1);
    setIndex(i);
  };
  // Auto-advance
  useEffect(() => {
    const id = setInterval(next, 4500);
    return () => clearInterval(id);
  }, [next]);
  const variants = {
    enter: (dir: number) => ({
      x: dir > 0 ? 60 : -60,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (dir: number) => ({
      x: dir > 0 ? -60 : 60,
      opacity: 0
    })
  };
  return <section className="py-16 lg:py-20 bg-white" data-id="element-20">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-22">
          <div className="inline-block bg-wc-yellow text-wc-dark font-bold px-4 py-1 rounded-full text-xs mb-4 uppercase tracking-wider" data-id="element-23">
            👀 Vista previa del material
          </div>
          <h2 className="text-xl md:text-2xl text-wc-dark mb-3 font-[800]" data-id="element-24">
            Mirá lo que recibís al comprar
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto font-[800]" data-id="element-25">
            Podés imprimirlas en papel adhesivo (autoadhesivo) y te quedan igual
            que las originales. ¡Solo recortás y pegás! A un Precio Increíble!
          </p>
        </motion.div>

        <div className="relative" data-id="element-26">
          {/* Carousel viewport */}
          <div className="relative bg-gradient-to-br from-gray-100 to-gray-200 rounded-3xl shadow-xl overflow-hidden aspect-[4/3] sm:aspect-[16/10] flex items-center justify-center" data-id="element-27">
            <AnimatePresence custom={direction} mode="wait" data-id="element-28">
              <motion.div key={index} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
              duration: 0.4,
              ease: 'easeOut'
            }} className="absolute inset-0 flex items-center justify-center p-4 sm:p-8" data-id="element-29">
                <img src={SLIDES[index].src} alt={SLIDES[index].caption} className="max-h-full max-w-full object-contain rounded-xl shadow-2xl" data-id="element-30" />
              </motion.div>
            </AnimatePresence>

            {/* Prev */}
            <button type="button" onClick={prev} aria-label="Anterior" className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-wc-dark rounded-full p-2 sm:p-3 shadow-lg transition-transform hover:scale-110 z-10" data-id="element-31">
              <ChevronLeft className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-32" />
            </button>

            {/* Next */}
            <button type="button" onClick={next} aria-label="Siguiente" className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-wc-dark rounded-full p-2 sm:p-3 shadow-lg transition-transform hover:scale-110 z-10" data-id="element-33">
              <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-34" />
            </button>

            {/* Counter */}
            <div className="absolute top-3 right-3 bg-wc-dark/80 backdrop-blur-sm text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-35">
              {index + 1} / {SLIDES.length}
            </div>
          </div>

          {/* Caption */}
          <motion.div key={`caption-${index}`} initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3
        }} className="mt-5 text-center text-gray-800 font-medium text-base sm:text-lg px-4" data-id="element-36">
            {SLIDES[index].caption}
          </motion.div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-5" data-id="element-37">
            {SLIDES.map((_, i) => <button key={i} onClick={() => goTo(i)} aria-label={`Ir a la imagen ${i + 1}`} className={`h-2.5 rounded-full transition-all duration-300 ${i === index ? 'bg-wc-red w-8' : 'bg-gray-300 hover:bg-gray-400 w-2.5'}`} data-id="element-38" />)}
          </div>
        </div>
      </div>
    </section>;
}